import React, {memo, useEffect, useState} from 'react';
import {useDispatch, useSelector} from 'react-redux';

import {
  HCheckbox,
  HDatePicker,
  HInput,
  HRadio,
  DSelect,
  passParamsThrough,
} from '../../../validation/HForm';
import { searchCriminal } from '../../../redux/actions/searchAction';
import {calculateAge, translationRuEnSameLetters} from '../../../helpers/common';
import { defaultCountry } from '../../../helpers/data-constants';

import './custom-forms.scss';

const ClientInfoAdd = memo(
  ({
     setValue,
     getValues,
     unregister,
     control,
     register,
     errors,
     reset,
     isLoading,
     country,
     handleOptions,
     defaultCountry: defaultClientCountry,
     tempEntity,
     watch,
     activeTab
   }) => {
    const { accessFeatures } = useSelector(({ user }) => user);
    const isExtendedForm = !!activeTab

    const props = {
      control,
      register,
      errors,
    };

      const initialValueDoB = tempEntity?.dateOfBirth ? calculateAge(tempEntity.dateOfBirth) : ''
      const [watchDateOfBirth, setWatchDateOfBirth] = useState(initialValueDoB)
      const isResidency = watch('client.residency')
      const isCountry = watch('client.citizenship')
      const defaultResidencyCoutry = defaultCountry

      const onBlurDateOfBirth = () => {
          setWatchDateOfBirth(calculateAge(watch('client.dateOfBirth')))
      }

    useEffect(() => {
      const isDefaultCountry = (countryLabel) => 
      countryLabel === defaultResidencyCoutry?.label;

      const shouldClearCitizenship = !isResidency && 
        (isDefaultCountry(isCountry?.label) || isDefaultCountry(defaultClientCountry?.label));

      if (shouldClearCitizenship) {
        setValue('client.citizenship', null);
      }
    }, [isResidency]);

    useEffect(()=>{
      const dateOfBirth = getValues().client.dateOfBirth
      dateOfBirth && setWatchDateOfBirth(calculateAge(dateOfBirth))
    },[])

    const wildcardNeed = false
    const dispatch = useDispatch();

    useEffect(() => {
      if (defaultClientCountry) {
        reset({
          'client.lastName': tempEntity.lastName,
          'client.firstName': tempEntity.firstName,
          'client.middleName': tempEntity.middleName,
          'client.gender': tempEntity.gender,
          'client.discountCard': tempEntity.discountCard,
          'client.placeOfBirth': tempEntity.placeOfBirth,
          'client.dateOfBirth': tempEntity.dateOfBirth,
          'client.personalNumber': tempEntity.personalNumber,
          'client.residency': tempEntity.residency,
          'client.payerAccountNumber': tempEntity.payerAccountNumber,
        });
      }
      return () => {
        if (unregister) {
          unregister('client.residency');
        }
      };
    }, []);

    const handleSearch = () => {
      const data = getValues().client;

      if (
        (data.firstName && data.lastName) ||
        (data.lastName && data.middleName) ||
        (data.firstName && data.middleName)
      ) {
        const term = `${data.lastName} ${data.firstName} ${data.middleName}`;
        dispatch(
          searchCriminal({
            size: 10,
            from: 0,
            term,
            wildcardNeed
          }),
        );
      }
    };

    return passParamsThrough(
      <div>
        <div className="form-row">
          <div className="form-row-item">
            <div className="form-element">
              <label className="form-element-label" htmlFor="clientSurname">
                Фамилия
              </label>
              <div className="form-element-data">
                <HInput
                  h="true"
                  className="input"
                  type="text"
                  name="client.lastName"
                  id="lastName"
                  onBlur={handleSearch}
                />
              </div>
            </div>
          </div>
          <div className="form-row-item">
            <div className="form-element">
              <label className="form-element-label" htmlFor="clientName">
                Собственное имя
              </label>
              <div className="form-element-data">
                <HInput
                  h="true"
                  className="input"
                  type="text"
                  name="client.firstName"
                  id="firstName"
                  onBlur={handleSearch}
                />
              </div>
            </div>
          </div>
          <div className="form-row-item">
            <div className="form-element">
              <label className="form-element-label" htmlFor="clientPatronymic">
                Отчество (при наличии)
              </label>
              <div className="form-element-data">
                <HInput
                  h="true"
                  className="input"
                  type="text"
                  name="client.middleName"
                  id="middleName"
                  onBlur={handleSearch}
                />
              </div>
            </div>
          </div>
        </div>
        <div className="form-row">
          <div className="form-row-item">
            <div className="form-element">
              <label className="form-element-label" htmlFor="clienSex">
                Пол
              </label>
              <div className="form-element-data">
                <div className="form-element-data-radios clientInfoAdd-radio">
                  <HRadio h="true" labels={['Мужской', 'Женский']} name="client.gender" />
                </div>
              </div>
            </div>
          </div>
          <div className="form-row-item">
            <div className="form-element">
              <label className="form-element-label" htmlFor="clientDiscountCard">
                Номер дисконтной карты
              </label>
              <div className="form-element-data">
                <HInput
                  h="true"
                  className="input"
                  type="text"
                  name="client.discountCard"
                  id="discountCard"
                />
              </div>
            </div>
          </div>
          {isExtendedForm && (
            <div className="form-row-item">
              <div className="form-element">
                <label
                  className="form-element-label"
                  htmlFor="clientHelperDescription"
                >
                  Учётный номер плательщика
                </label>
                <div className="form-element-data">
                  <HInput
                    h
                    className="input"
                    type="text"
                    name="client.payerAccountNumber"
                    id="payerAccountNumber"
                  />
                </div>
              </div>
            </div>
          )}
        </div>
        <div className="form-row">
          <div className="form-row-item">
            <div className="form-element">
              <label className="form-element-label" htmlFor="clientGr">
                Гражданство
              </label>
              <div className="form-element-data combobox">
                  <DSelect
                  h="true"
                  name="client.citizenship"
                  defaultValue={defaultClientCountry}
                  isLoading={isLoading}
                  options={country}
                  handleOptions={handleOptions}
                  placeholder="Введите страну"
                  isOptionDisabled={(option) => !isResidency && option.label === defaultResidencyCoutry.label}
                />
              </div>
            </div>
          </div>
          <div className="form-row-item">
            <div className="d-flex align-center h-100">
              <HCheckbox h="true" label="Резидент Республики Беларусь" name="client.residency" />
            </div>
          </div>
        </div>
        <div className="form-row">
          <div className="form-row-item">
            <div className="form-element">
              <label className="form-element-label" htmlFor="clientBirthPlace">
                Место рождения
              </label>
              <div className="form-element-data birthplace">
                <HInput
                  h="true"
                  className="input"
                  type="text"
                  name="client.placeOfBirth"
                  id="placeOfBirth"
                />
              </div>
            </div>
          </div>
          <div className="form-row-item">
            <div className="form-element">
              <label className="form-element-label" htmlFor="clientDateBirth">
                Дата рождения
              </label>
              <div className="form-element-data date">
                <HDatePicker
                  h="true"
                  className="input"
                  name="client.dateOfBirth"
                  id="dateOfBirth"
                  onBlur={onBlurDateOfBirth}
                />
                {accessFeatures['client.age'] && watchDateOfBirth && <span className="form-element-data-age">{`Возраст: ${watchDateOfBirth}`}</span>}
              </div>
            </div>
          </div>
          <div className="form-row-item">
            <div className="form-element">
              <label className="form-element-label" htmlFor="clientIdNumber">
                Идентификационный номер
              </label>
              <div className="form-element-data">
                <HInput
                  h="true"
                  className="input"
                  type="text"
                  name="client.personalNumber"
                  id="personalNumber"
                  onChange={(event) => translationRuEnSameLetters(event, setValue, "client.personalNumber", true)}
                  defaultValue={tempEntity?.personalNumber || ''}
                />
              </div>
            </div>
          </div>
        </div>
      </div>,
      props,
    );
  },
);

export default ClientInfoAdd;
